import { mergeClasses, __styles, shorthands } from '@griffel/react';
export const menuListClassNames = {
  root: 'fui-MenuList'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62",
    i8kkvl: "f16mnhsx",
    Belr9w4: "fbi42co"
  }
}, {
  d: [".f22iagw{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}", ".f1vx9l62{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".f16mnhsx{-webkit-column-gap:2px;column-gap:2px;}", ".fbi42co{row-gap:2px;}"]
});
/**
 * Apply styling to the Menu slots based on the state
 */
export const useMenuListStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(menuListClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useMenuListStyles.styles.js.map